import '../node_modules/cropper/dist/cropper.css'
import Vue from 'vue'
import App from './App'
import AppRouter from './Router'
import vueAsyncData from 'vue-async-data'
import vTouch from 'vue-touch'
import moment from 'vue-moment'
import vValidator from 'vue-validator'
import VueD3 from 'vue-d3'
import Sortable from 'vue-sortable'
import Vuex from 'vuex'
import videoStore from 'src/store/videoStore'
import vFire from 'vuefire'

Vue.use(vValidator)
Vue.use(AppRouter)
Vue.use(vueAsyncData)
Vue.use(vTouch)
Vue.use(moment)
Vue.use(VueD3)
Vue.use(Sortable)
Vue.use(Vuex)
Vue.use(vFire)
// use d3 as this.$d3
Vue.config.debug = true
Vue.config.devtools = true
Vue.config.warnExpressionErrors = false // this line hide then warning when {{ a.b }} a is null

// ============== Validators ==================
// @@Todo: set global msgs, would have a title ex: 'Name: msgmsgmsgmsg'
Vue.validator('email', val => {
  return /^[-a-z0-9~!$%^&*_=+}{\\'?]+(\.[-a-z0-9~!$%^&*_=+}{\\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i
    .test(val)
})
Vue.validator('assocCode', val => /^[0-9]{6}$/.test(val)) // for associate code
Vue.validator('numeric', val => /^[0-9]{1,}$/.test(val))
Vue.validator('ipAddress', val => {
  return /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
    .test(val)
})
Vue.validator('ipOrURL', val => {
  return /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(val) || /[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|[a-zA-Z0-9]\.[^\s]{2,}|[a-zA-Z0-9]\.[^\s]{2,}/.test(val)
})
Vue.validator('engAndNum', val => /^[0-9A-Za-z\s_]{1,}$/.test(val))
Vue.validator('deviceValid', val => /^[0-9A-Za-z\-_]{1,}$/.test(val))
Vue.validator('password', val => /^[0-9A-Za-z]{4,}$/.test(val))
// for Sequence time in Event.vue
Vue.validator('float', val => /^[0-9]+(.[0-9]{1,})?$/.test(val))
Vue.validator('int', val => /^-{0,1}[0-9]+/.test(val))

const router = new AppRouter({
  // Set to true to remove #! in path.
  // It needs proper configured server.
  // http://readystate4.com/2012/05/17/nginx-and-apache-rewrite-to-support-html5-pushstate/
  history: false
})
const application = Vue.extend({
  store: videoStore, // inject store to all children
  components: { App }
})
router.start(application, 'body')



// WEBPACK FOOTER //
// ./src/main.js